function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.5C0 2.91015 2.91015 0 6.5 0H25.5C29.0899 0 32 2.91015 32 6.5V25.5C32 29.0899 29.0899 32 25.5 32H6.5C2.91015 32 0 29.0899 0 25.5V6.5Z",
  fill: "#ED4C9D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.30595 23.386C4.61977 23.3857 3.99345 22.9953 3.69101 22.3794C3.38856 21.7634 3.46262 21.0291 3.88195 20.486L11.2909 10.881C11.3305 10.8272 11.3733 10.7757 11.4189 10.727C11.556 10.5785 11.7173 10.4544 11.8959 10.36C12.5724 10.0023 13.4011 10.1114 13.9619 10.632C14.0107 10.6769 14.0568 10.7246 14.0999 10.775L20.0119 17.349L25.6399 9.82198C26.0251 9.3068 26.6558 9.03622 27.2945 9.11217C27.9332 9.18812 28.4829 9.59905 28.7365 10.1902C28.9901 10.7813 28.9091 11.4628 28.524 11.978L21.5919 21.25C21.5551 21.2993 21.5157 21.3467 21.4739 21.392C21.4328 21.4378 21.3891 21.4812 21.3429 21.522C20.9879 21.8415 20.5204 22.0068 20.0435 21.9814C19.5665 21.9561 19.1192 21.7423 18.7999 21.387L12.8429 14.763L6.73295 22.686C6.39164 23.1281 5.86445 23.3867 5.30595 23.386Z",
  fill: "url(#paint0_linear_555:1503)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_555:1503",
  x1: 6.55195,
  y1: 22.5288,
  x2: 28.8819,
  y2: 22.5288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.75
})));

function SvgIconPredict(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPredict);
export default __webpack_public_path__ + "static/media/IconPredict.448bc3bc.svg";
export { ForwardRef as ReactComponent };